/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Case_NumberInputs */

const en_reports_col_case_number = /** @type {(inputs: Reports_Col_Case_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case number`)
};

const pt_br2_reports_col_case_number = /** @type {(inputs: Reports_Col_Case_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número Caso`)
};

/**
* | output |
* | --- |
* | "Case number" |
*
* @param {Reports_Col_Case_NumberInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_case_number = /** @type {((inputs?: Reports_Col_Case_NumberInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Case_NumberInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_case_number(inputs)
	return pt_br2_reports_col_case_number(inputs)
});